export const validateCnpj = (value) => {
  if (!value) return true;
  const baseValue = "0".charCodeAt(0);
  const cnpj = value.replace(/[^A-Z\d./-]/g, '');

  const multipliers = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const regex = /^([A-Z\d]){12}(\d){2}$/;
  if (!cnpj || cnpj.length !== 14 || !regex.test(cnpj) || /^0{14}$/.test(cnpj)) {
    return false;
  }

  let i, n;

  for (i = 0, n = 0; i < 12; i++) {
    n += (cnpj.charCodeAt(i) - baseValue) * multipliers[i + 1];
  }
  n = 11 - (n % 11);
  n = n >= 10 ? 0 : n;

  if (parseInt(cnpj[12], 10) !== n) return false;

  for (i = 0, n = 0; i <= 12; i++) {
    n += (cnpj.charCodeAt(i) - baseValue) * multipliers[i];
  }

  n = 11 - (n % 11);
  n = n >= 10 ? 0 : n;

  if (parseInt(cnpj[13], 10) !== n) return false;

  return true;
}